import { DatePeriodModel } from "../models/date-period.model";

export function getDateRangeByPeriod(period: DatePeriodModel): [Date, Date] {
  const today = new Date();
  switch (period) {
    case DatePeriodModel.ThisWeek:
      return [getStartOfWeek(), today];
    case DatePeriodModel.ThisMonth:
      return [getStartOfMonth(), today];
    case DatePeriodModel.ThisYear:
      return [new Date(today.getFullYear(), 0, 1), today];
    case DatePeriodModel.PreviousYear:
      return [
        new Date(today.getFullYear() - 1, 0, 1),
        new Date(today.getFullYear() - 1, 11, 31)
      ];
    default:
      return [null!, null!];
  }
}

function getStartOfWeek(): Date {
    const now = new Date();
    const day = now.getDay();
    const diff = now.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(now.setDate(diff));
}

function getStartOfMonth(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
} 